<template>
  <v-form @submit.prevent>
      <tiles-form :doc="doc" />
      <v-btn class="mt-5" @click="onSubmit">Submit</v-btn>
  </v-form>
</template>

<script>
// @ is an alias to /src
import TilesForm from "./Form"
import router from "@/router";

export default {
  name: "AdminGroupAdd",
  components: {
    TilesForm
  },
  data () {
    return {
      doc: {}
    }
  },
  methods: {
    onSubmit (evt) {
      evt.preventDefault()
      let ref = this.$parent.collection.doc();
      ref.set({
        createdOn: new Date(),
        id: ref.id,
        title: this.doc.title,
        project: this.doc.project,
        colour: this.doc.colour,
        users: this.doc.users,
      }).then(() => {
        router.push({ name: this.$parent.returnRoute })
      })
      .catch((error) => {
        alert("Error adding document: ", error);
      });
    }
  }
};
</script>
